<template>
  <div>
    <app-echart-doughnut :series="series" style="width: 100%" />

    <div
      class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1 mt-1"
    >
      <small></small>
      <small class="timeline-item-time text-nowrap text-muted ml-1"
        >Source: Insee
        {{
          this.demographyByPeriode.data[
            this.demographyByPeriode.data.length - 3
          ].year
        }}</small
      >
    </div>
  </div>
</template>

<script>
import AppEchartDoughnut from "@core/components/charts/echart/AppEchartDoughnut.vue";

export default {
  components: {
    AppEchartDoughnut,
  },
  props: {
    demographyByPeriode: {
      type: Object,
      required: true,
    },
  },
  data() {
    const data =
      this.demographyByPeriode.data[this.demographyByPeriode.data.length - 2]
        .household.move_in_age;

    return {
      series: [
        {
          name: "Ancienneté d'emménagement dans la résidence principale",
          type: "pie",
          radius: ["35%", "55%"],
          avoidLabelOverlap: true,
          tooltip: {
            formatter: "{a} <br/>{b} : {c} ({d}%)",
          },
          label: {
            show: true,
            formatter: "{name|{b}}\n{percent|{d}%}",
            fontSize: 15,
            rich: {
              percent: {
                fontSize: 14,
                color: "#999",
              },
            },
          },
          labelLine: {
            show: true,
            length: 15,
            length2: 15,
            maxSurfaceAngle: 50,
          },
          data: [
            {
              value: data.age_0_2,
              name: "Depuis moins \nde 2 ans",
            },
            {
              value: data.age_2_4,
              name: "De 2 à 4 ans",
            },
            {
              value: data.age_5_9,
              name: "De 5 à 9 ans",
            },
            {
              value: data.age_10_more,
              name: "Depuis plus \nde 10 ans",
            },
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss"></style>
